<template>
  <nav-bar title="修改监管用户基本信息" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <van-form @submit="handleSubmit">
      <Picker
        label="客户类型"
        :require="true"
        :columns="columns"
        :defaultVal="oldForm.userTypeName"
        @confirm-values="value => (oldForm.userType = value.dicVal)"
      />
      <Field name="companyName" :defaultValue="oldForm.companyName" label="客户名" :require="true" />
      <Field  name="creditNo" :defaultValue="oldForm.creditNo" label="客户代码"  :require="true"/>
      <Field name="userName" :defaultValue="oldForm.userName" label="联系人" :require="true" />
      <Field name="phoneNum" :defaultValue="oldForm.phoneNum" label="联系电话" :require="true" />
      <Picker
        label="街道"
        pickerType="cascader"
        :defaultVal="oldForm.streetName"
        @confirm-values="value => (oldForm.streetCode = value)"
      />

      <Field name="address" :defaultValue="oldForm.address" label="地址" :require="true" />
      <Picker
        label="供应商"
        :columns="companyList"
        text="name"
        :defaultVal="oldForm.supplyName"
        @confirm-values="getSupply"
      />
      <Field
        name="oldSupply"
        label="供应商名称"
        v-if="showSupplyName"
      />
      <Field name="illegalWeight" :defaultValue="oldForm.illegalWeight" label="日用量" :require="true" />
      <!-- <Field
        label="位置"
        :defaultValue="`${oldForm.latitude}, ${oldForm.longitude}`"
      /> -->
      <SelectPoint @get-value="selectPoint" :defaultValue="`${oldForm.latitude}, ${oldForm.longitude}`"  />
      <div class="btn-container">
        <van-button
          block
          type="primary"
          :loading="loading"
          loading-text="请稍后..."
          :disabled="loading"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>

  </Content>
</template>

<script>
import { getCustomerDetail, getMessListById, updateManageUser } from '@/api/customer'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useGetData } from '@/hooks/useGetData'
import { ref, reactive, watch } from 'vue'
import SelectPoint from '../NewCustomers/SelectPoint.vue'
import { useRouter } from 'vue-router'
import { Notify } from 'vant'
import {
  getCompanyList
} from '@/api/superviseHome'
export default {
  name: 'ModifyRegulatoryUser',
  components: { SelectPoint },
  props: ['id'],
  setup (props) {
    const oldForm = reactive({})
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getCustomerDetail, (data) => {
      for (const key in data) {
        oldForm[key] = data[key]
      }
    }, props.id)
    getDataLoading()
    // LIST
    const columns = ref([])
    useGetData(getMessListById, data => {
      columns.value = data
    })()
    const companyList = ref([])
    useGetData(getCompanyList, data => {
      companyList.value = data
    })()
    const companyId = ref('')
    const comFlag = ref('')
    const showSupplyName = ref(false)
    const getSupply = value => {
      companyId.value = value.id
      comFlag.value = value.comFlag
    }
    watch(companyId, (val) => {
      val === '-1000' ? showSupplyName.value = true : showSupplyName.value = false
    })
    // 选择位置
    const selectPoint = value => {
      oldForm.point = value
    }
    const router = useRouter()
    const loading = ref(false)
    const handleSubmit = (values) => {
      const params = { ...oldForm, ...values, companyId: companyId.value, comFlag: comFlag.value }
      loading.value = true
      updateManageUser(params).then(() => {
        router.back()
        loading.value = false
        Notify({ type: 'success', message: '操作成功' })
      }).catch(() => {
        loading.value = false
      })
      // onSubmit(formData)
    }

    return { getDataLoading, showLoading, isLoading, handleSubmit, columns, oldForm, selectPoint, loading, companyList, getSupply, showSupplyName }
  }
}
</script>

<style lang="scss" scoped>
.btn-container {
  margin: 16px;
}
</style>
